/* NUBE — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  /* Cada sección incluye este archivo para funcionar sola en el editor; si una página tiene
     varias, el navegador lo ejecuta varias veces. Solo la primera ejecución se activa
     (si no, cada clic se registraba N veces: p. ej. "+" sumaba 6). */
  if (window.__nbScriptsLoaded) return;
  window.__nbScriptsLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Titulares palabra a palabra */
  function initSplit(root) {
    root.querySelectorAll('[data-nb-split]:not([data-nb-split-done])').forEach(function (el) {
      el.setAttribute('data-nb-split-done', '');
      el.classList.add('nb-split');
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'nb-w';
              var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') { walk(child); }
        });
      })(el);
    });
  }

  /* Un único observador para todas las entradas */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target;
      if (t._nbMasks) { t._nbMasks.forEach(function (m) { m.classList.add('is-in'); }); t._nbMasks = null; }
      if (t._nbSelf !== false) t.classList.add('is-in');
      io.unobserve(t);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }) : null;

  function initReveal(root) {
    root.querySelectorAll('.nb-reveal, .nb-mask, [data-nb-split]').forEach(function (el) {
      if (reduce || !io) { el.classList.add('is-in'); return; }
      if (el.classList.contains('nb-mask')) {
        /* el recorte oculta el elemento: se vigila a su contenedor */
        var p = el.parentElement;
        if (!p._nbMasks) { p._nbMasks = []; if (!p.classList.contains('nb-reveal') && !p.hasAttribute('data-nb-split')) p._nbSelf = false; }
        p._nbMasks.push(el); io.observe(p);
        return;
      }
      io.observe(el);
    });
  }

  /* Parallax suave (solo transform) */
  var parallaxEls = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-nb-parallax]').forEach(function (el) { parallaxEls.push(el); });
  }

  /* Línea de progreso de los pasos */
  var progressEls = [];
  function initProgress(root) {
    root.querySelectorAll('[data-nb-progress]').forEach(function (el) { progressEls.push(el); });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-nb-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(1) + 'px,0)';
      });
      updateMaterial(vh);
      progressEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (vh * 0.6)));
        el.style.setProperty('--p', p.toFixed(3));
      });
      ticking = false;
    });
  }

  /* Escena fija del material: cambia la imagen según el texto que se está leyendo */
  var materialEls = [];
  function initMaterial(root) {
    root.querySelectorAll('[data-nb-material]').forEach(function (sec) {
      if (sec._nbMat) return; sec._nbMat = true;
      materialEls.push({ steps: sec.querySelectorAll('.nb-material__step'), imgs: sec.querySelectorAll('.nb-material__stage [data-idx]'), counter: sec.querySelector('.nb-material__counter'), cur: -1 });
    });
  }
  function updateMaterial(vh) {
    materialEls.forEach(function (m) {
      var i = 0;
      m.steps.forEach(function (s, j) { if (s.getBoundingClientRect().top < vh * 0.6) i = j; });
      if (i === m.cur) return; m.cur = i;
      m.steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
      m.imgs.forEach(function (im) { im.classList.toggle('is-active', +im.getAttribute('data-idx') === i); });
      if (m.counter) m.counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(m.steps.length).padStart(2, '0');
    });
  }

  /* Selector de colores de la portada */
  function initColores(root) {
    root.querySelectorAll('[data-nb-colores]').forEach(function (sec) {
      var sw = sec.querySelectorAll('.nb-swatch');
      var imgs = sec.querySelectorAll('.nb-colores__stage [data-idx]');
      var name = sec.querySelector('.nb-colores__name');
      var timer = null, current = 0;
      function go(i) {
        current = i;
        sw.forEach(function (b, j) { b.classList.toggle('is-active', i === j); b.setAttribute('aria-pressed', i === j); });
        imgs.forEach(function (im) { im.classList.toggle('is-active', +im.getAttribute('data-idx') === i); });
        if (name && sw[i]) name.innerHTML = '<span>' + sw[i].getAttribute('data-name') + '</span>';
      }
      sw.forEach(function (b, i) {
        b.addEventListener('click', function () { clearInterval(timer); go(i); });
        b.addEventListener('mouseenter', function () { clearInterval(timer); go(i); });
      });
      var auto = parseInt(sec.getAttribute('data-auto'), 10);
      if (auto > 0 && !reduce && sw.length > 1) {
        timer = setInterval(function () { go((current + 1) % sw.length); }, auto * 1000);
      }
      go(0);
    });
  }

  /* Acordeones con altura animada */
  function initAccordions(root) {
    root.querySelectorAll('.nb-faq__item').forEach(function (d) {
      var sum = d.querySelector('summary');
      var body = d.querySelector('.nb-faq__a');
      if (!sum || !body || reduce) return;
      sum.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          var h = body.scrollHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: 'cubic-bezier(.65,0,.35,1)' })
            .onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* Cifras animadas */
  function initCount(root) {
    root.querySelectorAll('[data-nb-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-nb-count').replace(',', '.'));
      var dec = (el.getAttribute('data-nb-count').split(/[.,]/)[1] || '').length;
      if (isNaN(target) || reduce || !('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; o.disconnect();
        var t0 = performance.now();
        (function step(t) {
          var k = Math.min(1, (t - t0) / 1600); k = 1 - Math.pow(1 - k, 4);
          el.textContent = (target * k).toFixed(dec).replace('.', ',');
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: .6 });
      o.observe(el);
    });
  }

  /* Inclinación sutil al cursor */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('[data-nb-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 5) + 'deg) rotateX(' + (-y * 5) + 'deg) translateY(-4px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Página de producto ---------- */
  function initPDP(root) {
    root.querySelectorAll('[data-nb-pdp]').forEach(function (pdp) {
      var dataEl = pdp.querySelector('[data-nb-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var money = pdp.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
      var main = pdp.querySelector('.nb-pdp__main');
      var allSlides = main ? Array.prototype.slice.call(main.querySelectorAll('img')) : [];
      var allThumbs = Array.prototype.slice.call(pdp.querySelectorAll('.nb-pdp__thumb'));
      var gallery = pdp.querySelector('.nb-pdp__gallery');
      var colorIdx = gallery ? parseInt(gallery.getAttribute('data-color-index'), 10) : -1;
      var thumbsBox = pdp.querySelector('.nb-pdp__thumbs');
      var navBox = pdp.querySelector('.nb-pdp__nav');
      /* fotos visibles = las del color elegido (o sin color asignado) */
      var slides = allSlides.filter(function (s) { return !s.hidden; });
      var thumbs = allThumbs.filter(function (t) { return !t.hidden; });
      var idInput = pdp.querySelector('input[name="id"]');
      var priceEl = pdp.querySelector('[data-nb-price]');
      var compareEl = pdp.querySelector('[data-nb-compare]');
      var saveEl = pdp.querySelector('[data-nb-save]');
      var addBtn = pdp.querySelector('.nb-pdp__add');
      var addLabel = pdp.querySelector('.nb-pdp__add-label');
      var labels = { add: addBtn ? addBtn.getAttribute('data-add') : '', sold: addBtn ? addBtn.getAttribute('data-sold') : '' };
      var cur = 0;

      function fmt(cents) {
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var noDec = Math.round(cents / 100).toString();
        return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
          .replace(/\{\{\s*amount\s*\}\}/, v);
      }
      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === cur); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === cur); });
        if (thumbs[cur]) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      allThumbs.forEach(function (t) { t.addEventListener('click', function () { var i = thumbs.indexOf(t); if (i > -1) show(i); }); });
      /* Sustituye toda la galería por las fotos del color indicado */
      function applyColor(color) {
        if (!allSlides.length || color == null) return;
        var vis = function (el) { var g = el.getAttribute('data-group') || ''; return g === '' || g === color; };
        allSlides.forEach(function (s) { s.hidden = !vis(s); s.classList.remove('is-active'); });
        allThumbs.forEach(function (t) { t.hidden = !vis(t); t.classList.remove('is-active'); });
        slides = allSlides.filter(function (s) { return !s.hidden; });
        thumbs = allThumbs.filter(function (t) { return !t.hidden; });
        var single = slides.length <= 1;
        if (thumbsBox) thumbsBox.hidden = single;
        if (navBox) navBox.hidden = single;
        if (gallery) gallery.classList.toggle('is-single', single);
        if (main) main.classList.remove('is-zoom');
        show(0);
      }
      var prev = pdp.querySelector('[data-nb-prev]'), next = pdp.querySelector('[data-nb-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
      if (main) {
        main.addEventListener('click', function () { if (window.matchMedia('(hover: hover)').matches) main.classList.toggle('is-zoom'); });
        main.addEventListener('mousemove', function (e) {
          if (!main.classList.contains('is-zoom')) return;
          var r = main.getBoundingClientRect();
          slides[cur].style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null;
        });
      }

      /* Variantes */
      var groups = pdp.querySelectorAll('[data-nb-option]');
      function selected() {
        var vals = [];
        groups.forEach(function (g) {
          var a = g.querySelector('.is-active');
          vals[+g.getAttribute('data-nb-option')] = a ? a.getAttribute('data-value') : null;
        });
        return vals;
      }
      function update() {
        if (!variants.length) return;
        var vals = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return vals[i] == null || vals[i] === o; }); });
        groups.forEach(function (g) {
          var a = g.querySelector('.is-active'); var lab = g.querySelector('[data-nb-selected]');
          if (a && lab) lab.textContent = a.getAttribute('data-label') || a.getAttribute('data-value');
          /* Tejido del color elegido (cada color puede tener un tejido distinto) */
          var mat = pdp.querySelector('[data-nb-material]');
          if (a && mat && a.hasAttribute('data-material')) {
            var m = a.getAttribute('data-material');
            mat.hidden = !m; mat.querySelector('span').textContent = m;
          }
        });
        if (!v) { if (addBtn) { addBtn.disabled = true; addLabel.textContent = labels.sold; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.textContent = onSale ? fmt(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
        if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? labels.add : labels.sold; }
        /* Foto de la variante; si el color no tiene foto propia, volver a la principal
           en vez de quedarse con la foto del color elegido antes */
        /* galería completa del color elegido */
        if (colorIdx > -1) applyColor(v.options[colorIdx]);
        else if (slides.length) show(v.featured_media_position ? v.featured_media_position - 1 : 0);
        var sticky = document.querySelector('[data-nb-sticky-price]');
        if (sticky) sticky.textContent = fmt(v.price);
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
      groups.forEach(function (g) {
        g.querySelectorAll('[data-value]').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('[data-value]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
            b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true'); update();
          });
        });
      });

      /* Cantidad */
      var qty = pdp.querySelector('.nb-qty input');
      pdp.querySelectorAll('[data-nb-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) + (+b.getAttribute('data-nb-qty'))); });
      });

      /* Añadir al carrito: abre el carrito lateral de Dawn */
      var form = pdp.querySelector('form[action*="/cart/add"]');
      if (form) form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return; // envío normal
        e.preventDefault();
        addBtn.classList.add('is-loading');
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { alert(res.description || res.message); return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        }).catch(function () { form.submit(); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });

      /* Barra fija de compra cuando el botón sale de pantalla */
      var bar = document.querySelector('[data-nb-sticky]');
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var below = en[0].boundingClientRect.top < 0;
          bar.classList.toggle('is-shown', !en[0].isIntersecting && below);
        }).observe(addBtn);
        var sb = bar.querySelector('button');
        if (sb) sb.addEventListener('click', function () { addBtn.click(); });
      }

      update();
    });
  }

  /* Hero producto: entrada, profundidad con ratón/scroll (suavizada) y pausa fuera de pantalla */
  function initHeroProducto(root) {
    root.querySelectorAll('[data-nb-hp]').forEach(function (sec) {
      if (sec._nbHp) return; sec._nbHp = true;
      var img = sec.querySelector('.nb-hp__float img');
      var started = false;
      var start = function () {
        if (started) return; started = true;
        void sec.offsetWidth; /* fuerza el estado inicial para que la transición se vea */
        setTimeout(function () { sec.classList.add('is-in', 'is-ready'); }, 30);
      };
      if (reduce) { sec.classList.add('is-in'); return; }
      if (img && !img.complete) { img.addEventListener('load', start, { once: true }); img.addEventListener('error', start, { once: true }); setTimeout(start, 2500); }
      else start();

      var depth = sec.querySelector('[data-nb-hp-depth]');
      var layers = sec.querySelectorAll('[data-nb-hp-layer]');
      var par = parseFloat(getComputedStyle(sec).getPropertyValue('--hp-par')) || 0;
      if (!depth || !par) return;
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var tx = 0, ty = 0, cx = 0, cy = 0, sy = 0, visible = true, raf = null;

      if (fine) {
        sec.addEventListener('pointermove', function (e) {
          var r = sec.getBoundingClientRect();
          tx = ((e.clientX - r.left) / r.width - .5) * 2;
          ty = ((e.clientY - r.top) / r.height - .5) * 2;
          loop();
        });
        sec.addEventListener('pointerleave', function () { tx = 0; ty = 0; loop(); });
      }
      window.addEventListener('scroll', function () { loop(); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          visible = en[0].isIntersecting;
          sec.classList.toggle('is-paused', !visible);
          if (visible) loop();
        }).observe(sec);
      }
      function frame() {
        raf = null;
        if (!visible) return;
        cx += (tx - cx) * .06; cy += (ty - cy) * .06;
        var h = sec.offsetHeight || 1;
        var prog = Math.min(1, Math.max(0, window.scrollY / h));
        sy = prog * par * 5;
        var k = par / 12;
        depth.style.transform = 'translate3d(' + (cx * 12 * k).toFixed(2) + 'px,' + (cy * 8 * k + sy).toFixed(2) + 'px,0) rotateY(' + (cx * 2.4 * k).toFixed(2) + 'deg) rotateX(' + (-cy * 1.6 * k).toFixed(2) + 'deg) scale(' + (1 - prog * .04).toFixed(4) + ')';
        layers.forEach(function (l) {
          var f = parseFloat(l.getAttribute('data-nb-hp-layer')) || 0;
          l.style.transform = 'translate3d(' + (-cx * 14 * k * f).toFixed(2) + 'px,' + (-cy * 10 * k * f - sy * f).toFixed(2) + 'px,0)';
        });
        if (Math.abs(tx - cx) > .002 || Math.abs(ty - cy) > .002) loop();
      }
      function loop() { if (!raf) raf = requestAnimationFrame(frame); }
      loop();
    });
  }

  /* Comparador antes/después: deslizador accesible (ratón, dedo y teclado) + gesto de invitación */
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-nb-ba]').forEach(function (ba) {
      if (ba._nbBa) return; ba._nbBa = true;
      var range = ba.querySelector('.nb-ba__range');
      if (!range) return;
      var set = function (v) { ba.style.setProperty('--pos', v + '%'); };
      range.addEventListener('input', function () { ba._touched = true; set(range.value); });
      if (reduce || !('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; o.disconnect();
        var base = +range.value, t0 = null;
        setTimeout(function () {
          (function step(t) {
            if (ba._touched) return;
            if (!t0) t0 = t;
            var k = Math.min(1, (t - t0) / 2600);
            /* barrido: desde la posición inicial hasta revelar el "después" y vuelta */
            var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
            var v = base - (base - 32) * Math.sin(e * Math.PI);
            set(v.toFixed(2)); range.value = Math.round(v);
            if (k < 1) requestAnimationFrame(step); else { set(base); range.value = base; }
          })(performance.now());
        }, 700);
      }, { threshold: .5 });
      o.observe(ba);
    });
  }

  /* Carril de momentos: flechas que avanzan de tarjeta en tarjeta */
  function initMomentos(root) {
    root.querySelectorAll('[data-nb-momentos]').forEach(function (sec) {
      if (sec._nbMom) return; sec._nbMom = true;
      var track = sec.querySelector('[data-nb-mom-track]');
      if (!track) return;
      var step = function (dir) {
        var card = track.querySelector('.nb-momento');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        track.scrollBy({ left: dir * ((card ? card.offsetWidth : 300) + gap), behavior: reduce ? 'auto' : 'smooth' });
      };
      var p = sec.querySelector('[data-nb-mom-prev]'), n = sec.querySelector('[data-nb-mom-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  function rescan() { parallaxEls = []; progressEls = []; initParallax(document); initProgress(document); }

  function initAll(root) {
    root = root || document;
    initSplit(root); initReveal(root); rescan();
    initHeroProducto(root); initBeforeAfter(root); initMomentos(root); initMaterial(root); initColores(root); initAccordions(root); initCount(root); initTilt(root); initPDP(root);
    root.querySelectorAll('.nb-hero').forEach(function (h) { requestAnimationFrame(function () { h.classList.add('is-loaded'); }); });
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* Editor de Shopify: reinicia al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
